/**
 * Creation source of the plan
 */ export var PlanCreationSourceKind;
(function(PlanCreationSourceKind) {
    /** External creation source */ PlanCreationSourceKind["External"] = "external";
    /** Publication creation source */ PlanCreationSourceKind["Publication"] = "publication";
})(PlanCreationSourceKind || (PlanCreationSourceKind = {}));
